import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { SmsUserPlantable } from './smsUserPlantable';
import { SmsResellerPlanTable } from './smsResellerplanTable';
import { renderErrorMessage } from 'src/lib/toastMessage';
import { mainResselerId } from 'src/lib/Enums';
import { axiosGetCall } from 'src/services/apisCall';
import { SmsAmountPlanTable } from './smsAmounttable';

const SmsPlanAssign = ({ user }) => {
  const [credits, setCredits] = useState([]);
  const [assignedPlan, setAssignedPlan] = useState([]);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState([]);
  const [forceLoad, setForceLoad] = useState(true);

  const getUserplanList = async () => {
    try {
      const params = { skip: '0', limit: '100' };
      const { data } = await axiosGetCall('getSmsAssignedPlanList', { userId: user?.userId, type: 'user' });
      setAssignedPlan(data);
    } catch (error) {
      console.error(error);
      renderErrorMessage(error?.message);
    }
  };

  const getAmountList = async () => {
    try {
      const params = { skip: '0', limit: '100' };
      const { data } = await axiosGetCall('getSmsUserAmount', { xUserId: user?.userId });
      const arr = [
        {
          Validity: data.Validity,
          currentAmount: data.currentAmount,
          reservedAmount: data.reservedAmount,
          totalAmount: data.totalAmount,
        },
      ];
      setAmount(arr);
    } catch (error) {
      console.error(error);
      renderErrorMessage(error?.message);
    }
  }
  const getCreatePlanList = async () => {
    try {
      let data;
      if (user?.userId === mainResselerId) {
        data = await axiosGetCall('getSmsPlansList', {});
        setCredits(data?.planList);
      }
      else {
        data = await axiosGetCall('getSmsAssignedPlanList', { userId: user?.parent_userid });
        setCredits(data?.data);
      }
    } catch (error) {
      console.error('getCredits', error);
      renderErrorMessage(error?.message);
    }
  };

  useEffect(() => {
    const load = async () => {
      if (!forceLoad) return;
      if (!user?.userId) return;
      try {
        // call both APIs concurrently
        await Promise.all([getCreatePlanList(), getUserplanList(), getAmountList()]);
      } catch (error) {
        console.error('SmsPlanAssign load error', error);
        renderErrorMessage(error?.message);
      } finally {
        setForceLoad(false);
      }
    };
    load();
  }, [forceLoad]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '18px',
        overflow: 'hidden',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
      }}
    >
      <SmsAmountPlanTable
        amount={amount}
        user={user}
        loading={loading}
        setForceLoad={setForceLoad} />


      <SmsUserPlantable
        assignedPlan={assignedPlan}
        user={user}
        setForceLoad={setForceLoad}
        loading={loading} />

      <SmsResellerPlanTable
        credits={credits}
        assignedPlan={assignedPlan}
        user={user}
        setForceLoad={setForceLoad}
        loading={loading}
      />
    </Box>
  );
};

export default SmsPlanAssign;
